import { IconProps } from 'icons/Credits.icon';
import React from 'react';

const TechnologiesIcon: React.FC<IconProps> = ({ color = '#020511' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.001 3H15.001C14.4487 3 14.001 3.44772 14.001 4V9C14.001 9.55228 14.4487 10 15.001 10H20.001C20.5533 10 21.001 9.55228 21.001 9V4C21.001 3.44772 20.5533 3 20.001 3Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 21.0001V8.00012C10 7.73491 9.89464 7.48055 9.70711 7.29302C9.51957 7.10548 9.26522 7.00012 9 7.00012H4C3.73478 7.00012 3.48043 7.10548 3.29289 7.29302C3.10536 7.48055 3 7.73491 3 8.00012V20.0001C3 20.2653 3.10536 20.5197 3.29289 20.7072C3.48043 20.8948 3.73478 21.0001 4 21.0001H16C16.2652 21.0001 16.5196 20.8948 16.7071 20.7072C16.8946 20.5197 17 20.2653 17 20.0001V15.0001C17 14.7349 16.8946 14.4806 16.7071 14.293C16.5196 14.1055 16.2652 14.0001 16 14.0001H3"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TechnologiesIcon;
